import { useState } from 'react';
import CustomersList from './components/CustomersList';
import CustomerForm from './components/CustomerForm';
import CustomerDetail from './components/CustomerDetail';
import Sidebar from '../dashboard/components/Sidebar';
import Header from '../dashboard/components/Header';
import { useNavigate } from 'react-router-dom';

export default function CustomersPage() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeView, setActiveView] = useState<'list' | 'form' | 'detail'>('list');
  const [selectedCustomer, setSelectedCustomer] = useState<any>(null);
  const navigate = useNavigate();

  const handleCreateNew = () => {
    setSelectedCustomer(null);
    setActiveView('form');
  };

  const handleEdit = (customer: any) => {
    setSelectedCustomer(customer);
    setActiveView('form');
  };

  const handleViewDetail = (customer: any) => {
    setSelectedCustomer(customer);
    setActiveView('detail');
  };

  const handleBack = () => {
    setSelectedCustomer(null);
    setActiveView('list');
  };

  const handleSave = () => {
    setActiveView('list');
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
      <div className="flex">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        
        <main className="flex-1 p-4 sm:p-6 lg:ml-64 pt-20 sm:pt-24">
          <div className="max-w-7xl mx-auto">
            {/* Header */}
            <div className="mb-6 sm:mb-8">
              <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => navigate('/dashboard')}
                    className="flex items-center justify-center w-10 h-10 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer"
                    title="Retour au tableau de bord"
                  >
                    <i className="ri-arrow-left-line text-xl text-gray-600"></i>
                  </button>
                  <div>
                    <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1 sm:mb-2">Référentiel Clients</h1>
                    <p className="text-sm sm:text-base text-gray-600">
                      Gestion complète des fiches clients et historique commercial
                    </p>
                  </div>
                </div>
                {activeView === 'list' && (
                  <button
                    onClick={handleCreateNew}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-medium transition-colors shadow-lg flex items-center justify-center space-x-2 cursor-pointer w-full sm:w-auto whitespace-nowrap"
                  >
                    <i className="ri-add-line text-lg"></i>
                    <span>Nouveau Client</span>
                  </button>
                )}
              </div>
            </div>

            {/* Content */}
            {activeView === 'list' && (
              <CustomersList
                onEdit={handleEdit}
                onViewDetail={handleViewDetail}
              />
            )}

            {activeView === 'form' && (
              <CustomerForm
                customer={selectedCustomer}
                onBack={handleBack}
                onSave={handleSave}
              />
            )}

            {activeView === 'detail' && selectedCustomer && (
              <CustomerDetail
                customer={selectedCustomer}
                onBack={handleBack}
                onEdit={handleEdit}
              />
            )}
          </div>
        </main>
      </div>
    </div>
  );
}